import React from 'react';
import PropTypes from 'prop-types';

const ArrowIcon = ({ width, height, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 10 5.999">
        <path d="M4.551.192L.18 4.863a.71.71 0 000 .944.6.6 0 00.883 0L5 1.6l3.937 4.207a.6.6 0 00.883 0 .71.71 0 000-.944L5.434.192a.6.6 0 00-.883 0z" fill={fill} fillRule="evenodd" />
    </svg>
);

ArrowIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};

ArrowIcon.defaultProps = {
    width: '10',
    height: '5.999',
    fill: '#333'
};

export default ArrowIcon;
